import React from "react";
import type { LocationDetails } from "@apac/hooks";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { Icon } from "@b2bportal/core-ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

interface FlightLabelProps extends LocationDetails {
  category?: "origin" | "destination";
  className?: string;
}

export const FlightLabel: React.FC<FlightLabelProps> = ({
  title = "",
  subtitle = "",
  category = "origin",
  className,
}) => {
  const [block, cn] = useModuleBEM(styles, "FlightLabel");

  return (
    <div className={clsx(block, className)}>
      <Icon
        className={cn("icon", { [category]: true })}
        iconName={IconNameEnum.airplane}
      />

      <div className={cn("container", { [category]: true })}>
        <span className={cn("title")}>{title}</span>
        <span className={cn("subtitle")}>{subtitle}</span>
      </div>
    </div>
  );
};
